module.exports = __webpack_public_path__ + "img/translator_ru.f5529e4.svg";